export default "__VITE_ASSET__7b581ad6__"